<template>
    <div class="scl-ad">
        <div class="header-title" v-html="$t('onlineLesson')"/>

        <v-form class="lesson-form" ref="lessonForm" style="align-items: flex-start; gap: 8px">
            <v-select :items="classes" item-text="classTitle" item-value="classId" :label="$t('class')" :rules="required"
                      v-model="lesson.classId" @change="filterCoursesByClass" outlined dense :no-data-text="$t('no_data')"/>
            <v-select :items="filteredCourses" item-text="courseTitle" item-value="courseId" :label="$t('course')"
                      :rules="required" v-model="lesson.courseId" outlined dense :no-data-text="$t('no_data')"/>
            <v-btn color="primary" @click="openVideoLesson" :disabled="isDisabled" v-text="`Старт`"/>
        </v-form>
    </div>
</template>

<script>
import ScheduleWeekService from '@/_services/schedule-week.service'
import OnlineLessonService from '@/_services/online-lesson.service'

export default {

  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    currentLang () {
      return this.$root.$i18n.locale
    }
  },

  data () {
    return {
      langObj: {
        ru: 'courseTitle',
        kg: 'courseTitleKG',
        en: 'courseCode'
      },
      required: [v => !!v || this.$t('Обязательное поле')],
      jitsiRoomName: '',
      lesson: {
        classId: '',
        courseId: ''
      },
      classes: [],
      filteredCourses: [],
      allData: [],
      isDisabled: false
    }
  },

  created () {
    this.fetchInstructorClassCourses()
  },

  methods: {
    fetchInstructorClassCourses () {
      ScheduleWeekService.getByInstructor(this.userProfile.personId).then((res) => {
        if (res.length) {
          this.allData = res.map((item) => {
            item.classTitle = `${item.classLevel} ${item.classLabel}`
            item.courseTitle = item[this.langObj[this.currentLang]]
            return item
          })
          this.classes = this.allData.filter((obj, index, selfArr) =>
            index === selfArr.findIndex((el) =>
              (el.classId === obj.classId)
            ))
        }
      }).catch((err) => {
        this.$toast.error(err)
      })
    },

    filterCoursesByClass (selectedClassId) {
      this.filteredCourses = this.allData.filter((course) =>
        course.classId === selectedClassId
      ).filter((obj, index, selfArr) =>
        index === selfArr.findIndex((el) =>
          (el.courseId === obj.courseId)
        ))
    },

    openVideoLesson () {
      if (this.$refs.lessonForm.validate()) {
        OnlineLessonService.createOnlineLesson({
          classId: this.lesson.classId,
          courseId: this.lesson.courseId,
          instructorId: this.userProfile.personId
        }).then((res) => {
          this.isDisabled = false
          window.open(res.url, '_blank')
        }).catch((err) => {
          this.$toast.error(err)
        })
        this.isDisabled = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-select {
    max-width: 300px;
}
        .lesson-form {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            margin-bottom: 20px;
        }

    @media screen and (max-width: 768px){
        .v-btn{
            width: 100%;
        }
        .lesson-form{
            flex-wrap: wrap;
        }
        .v-select {
            max-width: none;
            width: 100%;
        }
    }
</style>
